import { getDueInstantForComparison } from "./dueDateTime";

/**
 * Compute counts and amounts for closed / current-month / beyond-current-month.
 *
 * This is aligned with the Global Time Navigator semantics:
 * - "Current Month" = due date within the current calendar month
 * - "Beyond Current Month" = due date after end of current month
 * - "Closed" = status closed (independent of due date)
 */
export function computeTimePhased(items, monthStart, monthEnd) {
  let closedCount = 0,
    upcomingCount = 0,
    remainingCount = 0;
  let closedAmount = 0,
    upcomingAmount = 0,
    remainingAmount = 0;
  items.forEach((item) => {
    const status = (item.status || "").toLowerCase();
    const isClosed = status === "closed";
    const due = getDueInstantForComparison(item.due_date);
    const amt = parseFloat(item.amount) || 0;
    if (isClosed) {
      closedCount += 1;
      closedAmount += amt;
      return;
    }
    if (due == null || !due.isValid()) return;
    const t = due.valueOf();
    if (t >= monthStart.valueOf() && t <= monthEnd.valueOf()) {
      upcomingCount += 1;
      upcomingAmount += amt;
    } else {
      if (t > monthEnd.valueOf()) {
        remainingCount += 1;
        remainingAmount += amt;
      }
    }
  });
  return {
    closedCount,
    upcomingCount,
    remainingCount,
    closedAmount,
    upcomingAmount,
    remainingAmount,
  };
}
